import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import SvgIcon from '@mui/material/SvgIcon';
import Tooltip from '@mui/material/Tooltip';
import { useRecoilValue } from 'recoil';
import { useTranslation } from '../../../contexts/TranslationContext';
import {
  deviceListStateAtom,
  deviceModeAtom,
} from '../../../models/atoms/device_atoms';
import { MHMTypography } from '../MHM/MHMTypography';
import { computeMetrics } from './FleetMetrics';

export const MobileFleetMetrics = (
  _: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) => {
  const { t } = useTranslation();
  const totalDevices = useRecoilValue(deviceListStateAtom);
  const data = computeMetrics(totalDevices);
  const mode = useRecoilValue(deviceModeAtom);

  if (mode === 'archived') {
    return null;
  }

  return (
    <Paper data-testid="Fleet Metrics Component">
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        p={1}
      >
        {data.map(item => (
          <Stack
            key={item.title}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            gap={1}
            flexWrap="wrap"
          >
            <Tooltip title={t(item.title)} placement="left">
              <SvgIcon color="primary" inheritViewBox sx={{ fontSize: '20px' }}>
                <item.icon />
              </SvgIcon>
            </Tooltip>
            <MHMTypography fontSize="20px">{item.value}</MHMTypography>
          </Stack>
        ))}
      </Stack>
    </Paper>
  );
};
